import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, ChevronRight } from 'lucide-react';

/**
 * Reusable Breadcrumb component
 * @param {Array} items - Array of {label, href} objects (last item is current page if no currentPage provided)
 * @param {string} currentPage - Current page label
 * @param {boolean} showBack - Show back button (default true)
 */
const Breadcrumb = ({ items = [], currentPage, showBack = true }) => {
  const navigate = useNavigate();

  // If items array has elements but no currentPage, treat last item as current
  const breadcrumbItems = currentPage ? items : items.slice(0, -1);
  const finalPage = currentPage || (items.length > 0 ? items[items.length - 1]?.label : '');

  return (
    <div className="flex items-center gap-2 text-sm mb-6">
      {showBack && (
        <button 
          onClick={() => navigate(-1)} 
          className="flex items-center gap-1 text-white/40 hover:text-white transition-colors mr-2"
          data-testid="breadcrumb-back"
        >
          <ArrowLeft className="w-4 h-4" />
          <span>Back</span>
        </button>
      )}
      
      {breadcrumbItems.length > 0 && showBack && (
        <span className="text-white/20">/</span>
      )}
      
      {breadcrumbItems.map((item, index) => (
        <React.Fragment key={index}>
          {item.href ? (
            <Link 
              to={item.href} 
              className="text-white/50 hover:text-white transition-colors"
            >
              {item.label}
            </Link>
          ) : (
            <span className="text-white/50">{item.label}</span>
          )}
          <ChevronRight className="w-4 h-4 text-white/20" />
        </React.Fragment>
      ))}
      
      {finalPage && (
        <span className="text-white font-medium">{finalPage}</span>
      )}
    </div>
  );
};

export default Breadcrumb;
